import qs from 'qs';
import { IncomingMessage } from 'http';
import { ABTestConfig, defaultValues, FALLBACK_ABTEST_VALUES } from '../../@packages/shared';
import { MultipleABTestConfiguration } from './types';
import {
  ABTestTrafficSlotDescription,
  convertConfigToTrafficSlotAndCookieMap,
  createCookieConfig,
  defaultABTestCookieConfig,
  extractSavedSlotNumberFromRequest,
  generateTrafficSlotNumber,
  trafficSlotNumberToCookieConfig,
} from './abTestUtils';

const IS_PROD = process.env.NODE_ENV === 'production';

// TODO: We can use Next Router to get query strings and implement this function into the abTestingContext
export function applySortingOnABTestingIndiceUrlParam(req: IncomingMessage, abTestConfig: ABTestConfig): ABTestConfig {
  if (!req?.url?.includes('?')) {
    return abTestConfig;
  }

  const { sortingIndice = abTestConfig.config.SORTING_INDICE } = qs.parse(req.url.split('?')[1]);

  return {
    ...abTestConfig,
    config: {
      ...abTestConfig.config,
      SORTING_INDICE: sortingIndice as string,
    },
  };
}

export function createAbTestingMiddleware(setup: MultipleABTestConfiguration) {
  if (!setup.tests) {
    console.error('Possibly missing or malformed ABTest config');
  }

  let slotToConfigMap: Map<number, ABTestTrafficSlotDescription>;
  try {
    slotToConfigMap = convertConfigToTrafficSlotAndCookieMap(setup);
  } catch (e) {
    console.error(`AB Test config processing error - switching all to default: ${e.message}`, `${e.stack}`);
    slotToConfigMap = new Map();
  }

  return (req: IncomingMessage) => {
    const trafficSlotNumber = extractSavedSlotNumberFromRequest(req, setup) || generateTrafficSlotNumber(setup);
    const abTestSavedFactorCookieConfig = trafficSlotNumberToCookieConfig(trafficSlotNumber, setup, IS_PROD);
    const savedConfiguration = slotToConfigMap.get(trafficSlotNumber);
    const abTestCookieConfig = savedConfiguration
      ? createCookieConfig(savedConfiguration.cookieName, savedConfiguration.cookieValue, IS_PROD)
      : defaultABTestCookieConfig(trafficSlotNumber, IS_PROD);

    const fallbackConfigOverrides = setup?.fallbackConfig || {};

    const abTestConfig: ABTestConfig = {
      title: savedConfiguration?.title || FALLBACK_ABTEST_VALUES.title,
      variant: savedConfiguration?.variant || FALLBACK_ABTEST_VALUES.variant,
      trafficSlotNumber,
      config: {
        ...defaultValues,
        ...fallbackConfigOverrides,
        ...(savedConfiguration?.config || {}),
      },
    };

    return {
      abTestConfig,
      abTestCookieConfig,
      abTestSavedFactorCookieConfig,
    };
  };
}
